














import {
  defineComponent,
  PropType,
  computed,
} from '@vue/composition-api';
import { styleRecordPxToVm } from '@/shared/utils/style-unit';
import type { ComponentConfig } from '../../types';
import { useActivityClick } from '../../hooks/useActivityClick';

export default defineComponent({
  name: 'ActivityCommonStaticRectangle',
  props: {
    config: {
      type: Object as PropType<ComponentConfig>,
      required: true,
    },
    ubtCommonParams: {
      type: Object as PropType<Dictionary>,
      required: true,
    },
  },
  setup(props: { config: ComponentConfig, ubtCommonParams: Dictionary }) {
    /** 容器样式 */
    const containerStyle = computed(() => {
      const style: Record<string, string> = {
        width: '100%',
        ...props.config.containerStyle,
      };
      return styleRecordPxToVm(style);
    });

    /** 背景图片样式 */
    const backgroundStyle = computed(() => {
      const style: Record<string, string> = {
        width: '100%',
        height: '100%',
        ...props.config.backgroundStyle,
      };
      return styleRecordPxToVm(style);
    });

    /** 背景图片URL */
    const backgroundImageUrl = computed(() => props.config.backgroundImage?.default || '');

    /** 点击事件处理 */
    const { handleClick } = useActivityClick(props.config.customClick, props.ubtCommonParams);

    return {
      containerStyle,
      backgroundStyle,
      backgroundImageUrl,
      handleClick,
    };
  },
});
